import { lazy } from "react";

export const AdminLoginForm = lazy(() => import("./Login/index.form"));
export const AdminForgotPasswordForm = lazy(() =>
  import("./ForgotPassword/index.form")
);
export const ResetPasswordForm = lazy(() =>
  import("./ResetPassword/index.form")
);
export const AdminUpdateProfileForm = lazy(() =>
  import("./UpdateProfile/index.form")
);
export const AdminChangePasswordForm = lazy(() =>
  import("./ChangePassword/index.form")
);
export const AdminVerificationForm = lazy(() =>
  import("./OtpVerification/index.form")
);
export const PandingQueriesForm = lazy(() =>
  import("./ManageQueries/PendingQuery/index.form")
);

export const MasterFilterForm = lazy(() =>
  import("./MasterFilterForm/index.form")
);
export const ClaimTypeForm = lazy(() =>
  import("./Master/ClaimType/index.form")
);
export const CategoryTypeForm = lazy(() =>
  import("./Master/CategoryForm/index.form")
);
export const ReportCategoryForm = lazy(() =>
  import("./ReportCategory/index.form")
);

export const EditUserForm = lazy(() => import("./EditUser/index"));
export const SupportReplyForm = lazy(() =>
  import("./SupportReplyForm/index.form")
);
export * from "./ManageCms";
export { default as ManageRoleForm } from "./ManageRole/index.form";

export { default as ManageSubscriptionForm } from "./ManageSubscription/index.form";
export { default as ManagePackageForm } from "./ManagePackage/index.form";
export { default as CoupenForm } from "./CoupenForm/index.form";
